import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Skeleton className="skeleton-note-input" variant="rect" />
      {[1, 2].map(item => (
        <Box key={item} className="skeleton-note-item-container">
          <Skeleton className="skeleton-note-item-avatar" variant="circle" />
          <Box className="skeleton-note-item-ballon">
            <Skeleton variant="text" width="100%" />
            <Skeleton variant="text" width="40%" />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default Loading;
